import React, { useEffect, useState } from 'react';
import { initAnalyticsIfConsented } from '../services/firebase';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('consent.analytics');
      setVisible(stored !== 'granted' && stored !== 'denied');
    } catch {
      setVisible(false);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-4">
        <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-4 md:p-5">
          <div className="md:flex md:items-center md:justify-between">
            <div className="md:flex-1 md:mr-4">
              <p className="text-sm text-gray-700">
                Usamos cookies analíticas para mejorar el servicio. Activaremos Google Analytics solo si aceptas.
                Consulta la <a href="/privacy" className="text-blue-600 hover:underline">Política de Privacidad</a> y los <a href="/terms" className="text-blue-600 hover:underline">Términos</a>.
              </p>
            </div>
            <div className="mt-3 md:mt-0 flex items-center gap-2">
              <button
                onClick={() => {
                  try { localStorage.setItem('consent.analytics', 'denied'); } catch {}
                  setVisible(false);
                }}
                className="px-3 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
              >
                Rechazar
              </button>
              <button
                onClick={() => {
                  try { localStorage.setItem('consent.analytics', 'granted'); } catch {}
                  try { initAnalyticsIfConsented(); } catch {}
                  setVisible(false);
                }}
                className="px-3 py-2 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
















